import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import cls from 'classnames';
import styles from './Heading.less';
function Heading(props) {
    const { className, children, bright = true, appearance: HeadingComponent = 'h1' } = props;
    return (_jsx(HeadingComponent, { className: cls(styles.heading, { [styles.headingBright]: bright }, className), children: children }));
}
export default memo(Heading);
